export default {
  setOpened (state, payload) {
    state.openedModals = payload
  }
}